import * as React from 'react';
import { IWidget } from 'common/schema/widget/Widget';
import { Form, Input } from 'antd';
import { WidgetDynamicViewType } from 'common/schema/widget/dynamic/WidgetDynamic';
import { DynamicMetadataCompiler } from 'common/schema/metadata/DynamicMetadataCompiler';
import { useRequestCompileContext } from 'client/components/schema/requests/compile-context/RequestCompileContext';

export interface IFormWidgetDynamicFieldViewProps {
  widget: IWidget;
}

// TODO Gestire l'altezza degli span solo testo
export function FormWidgetDynamicFieldView(
  props: IFormWidgetDynamicFieldViewProps
) {
  const { widget } = props;

  const { procedure, request, requestPreview } = useRequestCompileContext();
  const value = DynamicMetadataCompiler.compileWidget(
    procedure,
    requestPreview,
    widget
  );

  if (widget.dynamic!.view === WidgetDynamicViewType.None) return null;

  return (
    <Form.Item label={widget.dynamic?.label}>
      {widget.dynamic!.view === WidgetDynamicViewType.Text && (
        <span>{value}</span>
      )}
      {widget.dynamic!.view === WidgetDynamicViewType.TextField && (
        <Input disabled value={value} />
      )}
    </Form.Item>
  );
}
